module.exports = __webpack_public_path__ + "img/ics_o_flight-takeoff.938cde69.svg";